
import { HttpHeaders } from '@angular/common/http';

export class AppGlobal {
  public static headers: HttpHeaders;
  public static getApiUrl(apiUrl: string) {
    const domainUrl = 'https://entieapi.knackbe.in';
    // const domainUrl = 'https://liveapi.entie.co';

    // const domainUrl = 'https://localhost:44381';

    return domainUrl + '/api/' + apiUrl;
    // let domainurl = window.location.host;
    //     if (window.location.host === 'localhost:4200' || 'entieapi.scrudu.in' ) {
    //         domainurl = '';
    //         return domainurl + '/api/' + apiUrl;
    //     } else {
    //         return domainurl + '/api/' + apiUrl;
    //     }
  }

  public static getHeaders() {
    const header = new HttpHeaders({ 'Content-Type': 'application-json' });
    header.append('Access-Control-Allow-origin', '*');
    return header;
  }
}
